import Reflux from "reflux";
import UserService from "../service/UserService";

var DomainActions = Reflux.createActions({
  addSubdomain: {},
  disableSubdomain: {},
  enableSubdomain: {},
  domainManageOpen: {},
  domainManageClose: {},
  domainSetupOpen: {},
  domainSetupClose: {},
  domainSetupUpdateConfig: {},
  domainSetupClearError: {},
  domainSetupSubmit: {},
  domainSetupNext: {},
  domainSetupPrev: {},
  renameSubdomain: {},
  selectDomain: {},
  updateView: {},
  checkDomainUsage: {},
  loadDomains: {},
  domainSettingsUpdated: {},
  loadRedirects: { asyncResult: true, children: ["complete", "fail"] },
  deleteRedirect: { asyncResult: true, children: ["complete", "fail"] },
  addRedirect: { asyncResult: true, children: ["complete", "fail"] },
});

DomainActions.loadRedirects.listen(function (data) {
  UserService.getDomainRedirects(data.userId, data.domainId).then(this.complete).catch(this.fail);
});

DomainActions.deleteRedirect.listen(function (data) {
  UserService.removeDomainRedirect(data.userId, data.domainId, data.redirectId)
    .then(this.complete)
    .catch(this.fail);
});

DomainActions.addRedirect.listen(function (data) {
  UserService.addDomainRedirect(data.userId, data.domainId, data.redirect)
    .then(this.complete)
    .catch(this.fail);
});

export default DomainActions;
